import { render, staticRenderFns } from "./BatchRecharge.vue?vue&type=template&id=56598cb1"
import script from "./BatchRecharge.vue?vue&type=script&lang=js"
export * from "./BatchRecharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports